// extracted by mini-css-extract-plugin
export default {"mainContainer":"TopToPage_mainContainer__8RiV2","icon":"TopToPage_icon__I3VGQ"};